import Alpine from 'alpinejs'
window.Alpine = Alpine
Alpine.start()

// slider
import { tns } from "tiny-slider/src/tiny-slider";

[].forEach.call(document.querySelectorAll('.productsSlider'), function (el) {
    tns({
        "container": "#center",
        "items": 1,
        "gutter": 0,
        "center": false,
        "loop": true,
        "swipeAngle": false,
        "mouseDrag": true,
        "speed": 400,
        "controlsText": ['<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-10 h-10">\n' +
        '  <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />\n' +
        '</svg>\n', '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-10 h-10">\n' +
        '  <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />\n' +
        '</svg>\n'],
        responsive: {
            640: {
                items: 2,
                "gutter": 32,
            },
            1024: {
                items: 3,
                "gutter": 64,
            }
        }
    });
});

